<div id="personSuspensionDialog">
  <div>
    <h1>New {{ data.personType }} Suspension</h1>
  </div>
  <div id="personSuspensionDialog-form" [formGroup]="suspensionForm">
    <div id="personSuspensionDialog-wrapper-suspentionReason">
      <label id="personSuspensionDialog-label-suspentionReason">Suspension Reason*</label>
      <uz-generic-search-select
        id="personSuspensionDialog-searchSelect-suspensionReason"
        [items]="suspensionReasons"
        [selected]="suspensionForm.value.suspensionReason"
        [placeholder]="'Select Reason*'"
        [property]="'name'"
        (selectItem)="handleSuspensionReasonSelected($event)"
      ></uz-generic-search-select>
    </div>

    <div
      *ngIf="suspensionForm.value.suspensionReason?.permanent"
      id="personSuspensionDialog-wrapper-permanentWarning"
      class="warning-message"
    >
      <mat-icon id="personSuspensionDialog-icon-permanentWarning" svgIcon="uz-warning-outline"></mat-icon>
      <span id="personSuspensionDialog-text-permanentWarning">
        The selected suspension reason warrants a permanent suspension. The rider will not be able to schedule new rides, and all rides
        scheduled after today will be canceled.
      </span>
    </div>

    <div *ngIf="!suspensionForm.value.suspensionReason?.permanent" id="personSuspensionDialog-wrapper-suspensionEffectiveDate">
      <label id="personSuspensionDialog-label-suspensionEffectiveDate">Effective Date*</label>
      <mat-form-field appearance="outline" (click)="startDatePicker.open()">
        <input
          matInput
          id="personSuspensionDialog-datepicker-suspensionEffectiveDate"
          [matDatepicker]="startDatePicker"
          [min]="minDate"
          placeholder="Start Date"
          formControlName="suspensionEffectiveDate"
        />
        <mat-icon matSuffix class="material-icons-two-tone">calendar_today</mat-icon>
        <mat-datepicker #startDatePicker></mat-datepicker>
        <mat-error
          *ngIf="suspensionForm.get('suspensionEffectiveDate')?.hasError('matDatepickerParse')"
          id="personSuspensionDialog-warning-suspensionEffectiveDateInvalid"
        >
          Please enter a valid start date (mm/dd/yyyy).
        </mat-error>
        <mat-error
          *ngIf="suspensionForm.get('suspensionEffectiveDate')?.hasError('matDatepickerMin')"
          id="personSuspensionDialog-warning-suspensionEffectiveDateMinDate"
        >
          The date cannot be in the past.
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="!suspensionForm.value.suspensionReason?.permanent" id="personSuspensionDialog-wrapper-suspensionDuration">
      <label id="personSuspensionDialog-label-suspensionDuration">Suspension Duration*</label>
      <mat-form-field appearance="outline">
        <mat-select
          id="personSuspensionDialog-select-suspensionDuration"
          placeholder="Select Duration*"
          formControlName="suspensionDuration"
        >
          <mat-option *ngFor="let duration of suspensionDurations" [value]="duration.value">{{ duration.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div id="personSuspensionDialog-wrapper-suspensionDetailNotes">
      <label id="personSuspensionDialog-label-suspensionDetailNotes">Suspension Detail*</label>
      <mat-form-field appearance="outline">
        <textarea
          id="personSuspensionDialog-text-suspensionDetailNotes"
          matInput
          placeholder="Enter suspension details*"
          maxlength="500"
          formControlName="suspensionDetailNotes"
          #suspensionDetails
        ></textarea>
        <mat-hint id="personSuspensionDialog-hint-suspensionDetailNotes" align="end">
          {{suspensionForm.get('suspensionDetailNotes')?.value?.length || 0}} / 500
        </mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="personSuspensionDialog-container-buttons">
    <afp-button id="personSuspensionDialog-button-clear" variant="clear" (click)="handleCancel()">Cancel</afp-button>
    <afp-button id="personSuspensionDialog-button-save" variant="primary" [disabled]="suspensionForm.invalid" (click)="handleSave()">
      Save
    </afp-button>
  </div>
</div>
